export default {"src":"/_next/static/media/Oral-and-Head-Neck-Cancer.a80af664.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};